export default __webpack_public_path__ + "static/ms-1561a131e9ce6ae63101da6ff224f9d9.jpg";